var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServices1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9804 6.29883V6.34752M20.9804 6.34752V17.5C20.9804 19.7091 19.1896 21.5 16.9804 21.5H7.01957C4.81043 21.5 3.01957 19.7091 3.01957 17.5L3.01957 6.3476M20.9804 6.34752C21.0361 6.05774 20.9758 5.74065 20.7634 5.47578L19.1258 3.10064C18.8207 2.72021 18.367 2.5 17.8884 2.5H6.1116C5.63299 2.5 5.1793 2.72021 4.87415 3.10064L3.23664 5.47578C3.02417 5.74068 2.9639 6.0578 3.01957 6.3476M20.9804 6.34752C20.8916 6.80994 20.5077 7.20279 19.9759 7.20279H17.8884M3.01957 6.3476C3.10839 6.80999 3.49237 7.20279 4.02411 7.20279H6.1116M17.8884 7.20279H6.1116M17.8884 7.20279V3.03174M6.1116 7.20279V3.10064M10.0696 13.3798L7.40687 12.8104L9.14652 17.5633L16.3952 16.216L16.4069 11.0143L14.0282 12.5694L11.685 10.5325L10.0696 13.3798Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices1);
export default __webpack_public_path__ + "static/media/services_1.19cd8c474c383208a747bd5d2833ac5c.svg";
export { ForwardRef as ReactComponent };